// Packages
import { v4 as uuidv4 } from "uuid";

// Img
import icn_btn_block_dark from "assets/images/icons/icn_btn_block_dark.svg";
import icn_table_cell_Allow from "assets/images/icons/icn_table_cell_Allow.svg";

export const defaultActionsDefinition = {
  blockClient: {
    key: "blockClient",
    icon: icn_btn_block_dark,
    permissions: ["org", "site"],
    label: {
      actionButton: "Block",
      cancelButton: "Cancel",
      submitButton: "Block",
      modal: "Block Client",
      description: count => (<>{`Are you sure you want to block ${count} client(s)?`}</>)
    },
    uuid: uuidv4(),
    isOpenModal: false,
  },
  allowAccess: {
    key: "allowAccess",
    icon: icn_table_cell_Allow,
    permissions: ["org", "site"],
    label: {
      actionButton: "Allow",
      cancelButton: "Cancel",
      submitButton: "Allow",
      modal: "Allow Access",
      description: count => (<>{`Are you sure you want to allow ${count} client(s)?`}</>)
    },
    uuid: uuidv4(),
    isOpenModal: false,
  },
};